import { FC } from 'react';
import ImportSupplementsCleanUpList from '@views/AdminPage/ImportMedications/ImportSupplementsCleanUpList';
import ImportSynonymsList from '@views/AdminPage/ImportMedications/ImportSynonymsList';
import HighRiskSupplementsList from '@views/AdminPage/ImportMedications/HighRiskSupplementsList';
import ImportIngredientsCleanUpList from '@views/AdminPage/ImportMedications/ImportIngredientsCleanUpList';
import ImportMedicationsList from '@views/AdminPage/ImportMedications/ImportMedicationsList';

import './style.scss';

const ImportMedications: FC = () => (
  <div className="import-medications">
    <ImportSupplementsCleanUpList />
    <ImportIngredientsCleanUpList />
    <ImportMedicationsList />
    <ImportSynonymsList />
    <HighRiskSupplementsList />
  </div>
);

export default ImportMedications;
